import React from 'react'
import { Small } from 'rebass'

const Copyright = props => <Small {...props} fontSize={[0, 1, 2]} />

export default Copyright



// WEBPACK FOOTER //
// ./src/containers/Layout/Footer/Copyright.js